import { render, staticRenderFns } from "./DetalheArtigo.vue?vue&type=template&id=015ec099"
import script from "./DetalheArtigo.vue?vue&type=script&lang=js"
export * from "./DetalheArtigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports